import { ReactNode, ComponentProps } from "react";
import { getStepStatus, StepStatus } from "./getStepStatus";
import { twMerge } from "tailwind-merge";

export interface IStep {
  label: string;
  icon?: ReactNode;
}

export interface IStepIndicatorProps extends ComponentProps<"div"> {
  steps: IStep[];
  activeStep: number;
}

const formatStepNumber = (index: number) => String(index + 1).padStart(2, "0");

const circleClasses: Record<StepStatus, string> = {
  completed: "bg-[#8ac9bc] border-[#8ac9bc]",
  current: "bg-transparent border-[#8ac9bc] text-[#8ac9bc]",
  pending: "bg-transparent border-[#b8bfbc] text-[#b8bfbc]",
};

const labelClasses: Record<StepStatus, string> = {
  completed: "text-[#20332f] font-bold",
  current: "text-[#20332f] font-bold",
  pending: "text-[#b8bfbc] font-normal",
};

const connectorClasses: Record<StepStatus, string> = {
  completed: "bg-[#8ac9bc]",
  current: "bg-[#b8bfbc]",
  pending: "bg-[#b8bfbc]",
};

export const StepIndicator = ({
  steps,
  activeStep,
  className,
}: IStepIndicatorProps) => {
  return (
    <div className={twMerge("flex items-start w-full", className)}>
      {steps.map((step, index) => {
        const status = getStepStatus(index, activeStep, steps.length);
        const isLast = index === steps.length - 1;

        return (
          <div
            key={`${step.label}-${index}`}
            className="flex items-center flex-1"
          >
            <div className="flex items-center gap-2 shrink-0">
              <div
                data-status={status}
                className={`flex items-center justify-center w-5 h-5 rounded-full shrink-0 border border-solid font-['Inter'] text-[8px] font-bold ${circleClasses[status]}`}
              >
                {status === "completed" ? (
                  <img
                    src="/assets/svgs/icon-step-done.svg"
                    alt="etapa concluída"
                    className="w-2.5 h-2.5"
                  />
                ) : (
                  (step.icon ?? formatStepNumber(index))
                )}
              </div>
              <span
                data-status={status}
                className={`font-['Mulish'] text-xs whitespace-nowrap ${labelClasses[status]}`}
              >
                {step.label}
              </span>
            </div>
            {!isLast && (
              <div
                data-status={status}
                data-testid="step-connector"
                className={`flex-1 h-px mx-2 ${connectorClasses[status]}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
